import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';
import { useStyletron } from 'baseui';
import { Card, EMPTY_STRING } from 'commons-ui';

import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { USER_PAYMENTS_STATUS_RESOURCES, USER_PROFILE_RESOURCES } from 'constant';

import { UserDetailsContext } from 'context/userDetails';
import { URL, LABEL, IMAGE_SOURCE } from './helper';

const usePaymentStatusHome = () => {
	const { hasPermission: hasPermissionV2 } = usePermissionV2();

	const isEnabled = (configResourceName: string) => {
		return hasPermissionV2({
			configPageName: USER_PROFILE_RESOURCES.paymentsStatus,
			configResourceName
		});
	};

	return { isEnabled };
};

const PaymentStatusHome: React.FC<{}> = () => {
	const [css] = useStyletron();
	const history = useHistory();
	const { isEnabled } = usePaymentStatusHome();
	const { userSearchDetails } = useContext(UserDetailsContext);
	const queryParams = _get(history, ['location', 'search']);

	if (_isEmpty(queryParams)) {
		if (_isEmpty(userSearchDetails)) {
			history.push('/userProfile/selectUser');
		} else {
			const { selectionType, selectedValue } = userSearchDetails;
			history.push({
				pathname: '/paymentsStatus/home',
				search: `?${queryString.stringify({ [selectionType || EMPTY_STRING]: selectedValue })}`
			});
		}
	}

	return (
		<div className={css({ display: 'flex', flexDirection: 'column', gap: '70px', marginTop: '70px', marginBottom: '70px' })}>
			<div
				className={css({
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-evenly',
					alignItems: 'center',
					height: '100%',
					flexWrap: 'wrap',
					gap: '25px'
				})}>
				{_map(_keys(USER_PAYMENTS_STATUS_RESOURCES), (resourceName: string) => {
					return isEnabled(resourceName) ? (
						<div
							key={resourceName}
							className={css({
								height: '130px',
								width: '30%',
								cursor: 'pointer',
								display: 'flex',
								justifyContent: 'space-around'
							})}
							role='button'
							tabIndex={0}
							onClick={(e) => {
								e.preventDefault();

								history.push({
									pathname: URL[resourceName],
									search: _get(history, ['location', 'search'], '')
								});
							}}>
							<Card label={LABEL[resourceName]} img={IMAGE_SOURCE[resourceName]} />
						</div>
					) : null;
				})}
			</div>
		</div>
	);
};

export default PaymentStatusHome;
